import React from "react";

import { DebugMenu } from "@/features/react-editor/components/navbar/DebugMenu";
import { useChatSidebar } from "@/features/react-editor/hooks/useChatSidebar";
import IconButton from "@replo/design-system/components/button/IconButton";
import { useSidebar } from "@replo/design-system/components/shadcn/core/sidebar";
import { Menu, MessagesSquare } from "lucide-react";

export default function MobileChatHeader() {
  const { toggleSidebar } = useSidebar();
  const { toggle } = useChatSidebar();
  return (
    <div className="md:hidden fixed top-0 left-0 right-0 z-40 bg-white w-full flex items-center justify-between h-14 px-3 border-b-0.5 border-border">
      <IconButton
        variant="tertiary"
        size="lg"
        icon={<Menu size={20} />}
        tooltipText="Menu"
        onClick={toggleSidebar}
        aria-label="Open menu"
      />
      <DebugMenu />
      <IconButton
        variant="tertiary"
        size="lg"
        icon={<MessagesSquare size={20} />}
        tooltipText="Chats"
        onClick={toggle}
        aria-label="Open chats"
      />
    </div>
  );
}
